exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead th {\n    cursor: pointer;\n    margin-right: 15px;\n    margin-left: 15px;\n  \n    span {\n      visibility: hidden;\n    }\n  \n    &.active {\n      color: #000;\n  \n      span {\n        visibility: visible;\n      }\n    }\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/company/company.component.css
// module id = ../../../../../src/app/components/pages/company/company.component.css
// module chunks = main